import Handlebars from "handlebars";
import "#legacy/handlebars_helpers/random_id_helper.js";
import "#legacy/handlebars_helpers/device_media_helper.js";
import "#legacy/handlebars_helpers/variant_url_helper.js";

(function (global) {
  Handlebars.registerHelper("responsiveBackground", function (image, options) {
    this.backgroundId = Handlebars.helpers.randomId();
    this.image = image;
    if (image && image.variants) {
      // Descending precedence because in css we want the highest precedence at the bottom.
      this.variants = Handlebars.helpers.descendingDevicePrecedence(image.variants);
    }

    var styles = Handlebars.compile(
      '<style>\
    [data-responsive-background-id="{{ backgroundId }}"] {\
      background-image: url("{{ image.url }}");\
    }\
    \
    {{#each variants }}\
      @media {{deviceMedia @key }} {\
        [data-responsive-background-id="{{ ../backgroundId }}"] {\
          background-image: url("{{ variantUrl ../image.id @key this }}");\
        }\
      }\
    {{/each}}\
    </style>',
    );

    var output = options.fn(this);

    if (image) {
      output = styles(this) + output;
    }

    return output;
  });
})(typeof window !== "undefined" ? window : this);
